import React from "react"

interface DocumentExchangeIconProps {
  className?: string
}
export const DocumentExchangeIcon: React.FC<DocumentExchangeIconProps> = ({
  className = "text-white",
}) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_945_20388)">
      <path
        d="M37.8977 12.1924C38.6682 10.2788 38.6471 8.13746 37.8388 6.23947C37.0306 4.34147 35.5015 2.84229 33.5879 2.07171C31.6743 1.30114 29.533 1.3223 27.635 2.13053C25.737 2.93877 24.2378 4.46788 23.4672 6.38147M27.777 6.38147L22.9346 6.38147L22.9346 1.53905"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5415 5.84888V12.5166C15.5415 12.9587 15.7171 13.3827 16.0297 13.6953C16.3424 14.0079 16.7663 14.1836 17.2084 14.1836H23.8762"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.540527 20.8489V9.18221C0.540527 8.29816 0.891717 7.45031 1.51684 6.82519C2.14196 6.20007 2.98981 5.84888 3.87386 5.84888H15.5405L23.8739 14.1822V20.8489"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.540527 35.848H23.8739"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.540527 30.8485H23.8739"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.540527 25.849H23.8739"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_945_20388">
        <rect
          width="40"
          height="40"
          fill="currentColor"
          transform="translate(0 -0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
)
